const ISO_DATE = /\d{4}-\d{1,2}-\d{1,2}/;
const ISO_TIME_OF_DAY = /(\d{1,2}):(\d{2})\s[AP]M/;

// Display name pattern
const DISPLAY_NAME = /^[a-z|A-Z| -]*$/;

// http://www.regular-expressions.info/email.html
const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EMAIL_OPTIONAL = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// https://regexr.com/37i6s
// is empty or matches the pattern
const URL = /^$|^(https?):\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

const IP_ADDRESS = /^((25[0-5]|(2[0-4]|1[0-9]|[1-9]|)[0-9])(\.(?!$)|$)){4}$/;

const HEX_CODE = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;

const ABN = /^(\d *?){11}$/;

const LETTERS = /[a-zA-Z]/g;

const NUMERIC = /^\d+$/;

export const patterns = {
  ISO_DATE,
  ISO_TIME_OF_DAY,
  EMAIL,
  EMAIL_OPTIONAL,
  DISPLAY_NAME,
  URL,
  IP_ADDRESS,
  HEX_CODE,
  ABN,
  LETTERS,
  NUMERIC
};
